import React, { createContext, useContext } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { Button, Card, List, message, Tooltip } from "antd";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";

import { observer } from "mobx-react-lite";
import MainStore from "../store/mainStore";
import ebendo from "../component/images/oil-drill.svg";
import naoc from "../component/images/oil-rig.svg";
import quaibo from "../component/images/refinery.svg";
import PreferenceStore from "../store/preferenceStore";
import RequestStore from "../../productiondata/approvals/store/requeststore";
import { toJS } from "mobx";
const _ = require("underscore");
const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};

const modalPropsStyles = { main: { maxWidth: 600 } };

const dialogContentProps = {
  type: DialogType.largeHeader,
  title: "Workspace Asset",
  subText:
    "Choose the asset you want to set as your active workspace or context asset",
};

const prefStore = createContext(PreferenceStore);
const mainstore = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);
export const AssetContext = observer(() => {
  const preferenceStore = useContext(prefStore);
  const requestStore = useContext(requestStoreCtx);
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: dragOptions,
    }),
    []
  );

  const savePreference = async (assetContextId, name) => {
    let pref = preferenceStore.preference;
    preferenceStore.preference = {
      ...pref,
      assetContextId: assetContextId,
      assetContext: name,
    };

    await preferenceStore.savePreference(toJS(preferenceStore.preference));
  };
  const mainStore = useContext(mainstore);
  return (
    <Dialog
      hidden={!mainStore.showContextDialog}
      onDismiss={() => {
        mainStore.showContextDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={600}
    >
      <List
        grid={{ gutter: 20, column: 4 }}
        bordered={false}
        dataSource={[...mainStore.assets.values()]}
        renderItem={(item) => (
          <List.Item>
            <Tooltip title={`Set ${item.name} Asset as Active Workspace Asset`}>
              <Card
                title={
                  item.value === 1 ? (
                    <img src={naoc} style={{ width: "100px" }} alt="NAOC"></img>
                  ) : item.value === 2 ? (
                    <img
                      src={ebendo}
                      alt="Ebendo"
                      style={{ width: "100px" }}
                    ></img>
                  ) : (
                    <img
                      src={quaibo}
                      alt="QuaIbo"
                      style={{ width: "100px" }}
                    ></img>
                  )
                }
                style={{
                  cursor: "pointer",
                  backgroundColor: "#E2E8F0",
                  textAlign: "center",
                }}
                onClick={async () => {
                  mainStore.assetContextId = item.value;
                  mainStore.assetContextName = item.name;

                  mainStore.showContextDialog = false;

                  const defaultValue = _.first(
                    _.where([...mainStore.assets.values()], {
                      assetId: mainStore.assetContextId,
                    })
                  )?.defaultEquity;
                  message.info(
                    `${item.name} is the current asset active workspace`
                  );
                  mainStore.defaultEquity = defaultValue;
                  await savePreference(
                    mainStore.assetContextId,
                    mainStore.assetContextName
                  );

                  //clear the producing days in the requeststore to avoid haging production days values
                  requestStore.producingDays = [];
                }}
              >
                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                  {item.name}
                </div>
              </Card>
            </Tooltip>
          </List.Item>
        )}
      />
      <DialogFooter>
        <Button
          type="link"
          onClick={() => {
            mainStore.showContextDialog = false;
          }}
        >
          Close
        </Button>
      </DialogFooter>
    </Dialog>
  );
});

